/**
 * 导入数据模式
 * @param New 新增
 * @param Update 仅更新
 * @param UpdateAndNew 更新或新增
 */
enum ImportMode {
    /**
     * 新增
     */
    New,
    /**
     * 仅更新
     */
    Update,
    /**
     * 更新或新增
     */
    UpdateAndNew
}

/**
 * 更新数据依据选择模式
 * @param ContentItemId 数据Id
 * @param Primarykey 主键
 */
enum UpdateQueryMode{
    /**
     * 数据Id
     */
    ContentItemId,
    /**
     * 主键
     */
    Primarykey
}


/**
 * 导入数据操作步骤
 * @param Upload 上传excel
 * @param Preview 预览数据
 * @param ConfigData 配置导入的数据列
 * @param ConfigFlow 配置导入的流程节点
 * @param Result 导入结果
 */
enum ImportStep{
    /**
     * 上传excel
     */
    Upload,
    /**
     * 预览数据
     */
    Preview,
    /**
     * 配置导入的数据列
     */
    ConfigData,
    /**
     * 配置导入的流程节点
     */
    ConfigFlow,
    /**
     * 导入结果
     */
    Result
}

/**
 * 导入流程数据节点设置
 * @param Start 起始节点
 * @param End 结束节点
 */
enum CreateFlowNodeSetting
{
    Start,
    End
}

export {
    ImportMode,
    UpdateQueryMode,
    ImportStep,
    CreateFlowNodeSetting
}
